// Beta waitlist gate — frontend flag.
//
// When true, unapproved users see the "we're in beta — join the waitlist" popup
// instead of the dashboard after sign-in/sign-up. Flip to false to disable the
// gate entirely (normal signup/signin, no popup).
//
// NOTE: this only controls the UI. The BACKEND enforces the gate via its own
// env flag (WAITLIST_MODE in api/src/config/env.js). To turn the gate on or off
// for real, set BOTH this constant and the backend env flag to match.
module.exports = {
  WAITLIST_MODE: true
};
